














import Vue from 'vue'
import Component from 'vue-class-component'
import { Inject, Prop } from 'vue-property-decorator'
import { FormGroup } from '@tf/forms'
import { FormControl } from '@tf/forms/build/form-control'
import { Hooks } from '@/shared/interfaces/hooks'
import { loggerFor } from '@/shared/utils/logger'
import { debounce } from '@/shared/utils/debounce'

@Component({
  name: 'tf-input',
})
export default class TfInput extends Vue implements Hooks {
  @Inject('form')
  public readonly form!: FormGroup<any>

  @Prop({
    default: 'off',
    required: false,
    type: String,
  })
  public readonly autocomplete!: string

  @Prop({
    required: true,
    type: String,
  })
  public readonly control!: string

  @Prop({
    required: false,
    type: String,
  })
  public readonly id?: string

  @Prop({
    required: false,
    type: String,
  })
  public readonly placeholder?: string

  @Prop({
    default: () => 'text',
    required: false,
    type: String,
  })
  public readonly type!: string

  public value: any = null

  private debouncedMarkTouched = debounce(() => this.markTouched(), 1000)
  private logger = loggerFor(`Input ${this.control}`)

  public get controlId(): string {
    return this.id ?? this.control
  }

  public get dirty(): boolean {
    return this.formControl.dirty && this.formControl.touched
  }

  public get formControl(): FormControl<any> {
    return this.form.get(this.control)
  }

  public get invalid(): boolean {
    return (this.dirty && this.formControl.invalid) ?? false
  }

  public get valid(): boolean {
    return (this.dirty && this.formControl.valid) ?? true
  }

  public mounted() {
    this.formControl.onChange(value => {
      this.value = value
    })

    this.value = this.formControl.value
  }

  public markTouched(): void {
    this.formControl.markTouched()
  }

  public propagateChange(value: string): void {
    if (this.formControl.touched === false) {
      this.debouncedMarkTouched()
    }

    this.formControl
      .setValue(value)
      .markDirty()
      .validate()

    this.$emit('input', value)
  }
}
